import type { Address } from 'src/components/checkout/steps/shipping/types'
import type { AddressData } from 'src/sdk/checkout/data/types/orderformAPI'

const REFERENCE_FIELD_KEYS = [
  'reference',
  'apelido',
  'addressName',
  'AddressName',
  'label',
  'nickname',
] as const

/** Resolves apelido from VTEX/account payloads (field name varies by source). */
export function resolveAddressReferenceLabel(
  address?: AddressData | Address | Record<string, unknown> | null
): string {
  const source = (address ?? {}) as Record<string, unknown>

  for (const key of REFERENCE_FIELD_KEYS) {
    const candidate = source[key]

    if (typeof candidate !== 'string') {
      continue
    }

    const trimmed = candidate.trim()

    if (trimmed) {
      return trimmed
    }
  }

  return ''
}
